module.exports = __webpack_public_path__ + "img/journal2_TH copy.aa124a0b.png";